/*
 *  main.js
 *
 *  Here you can include all js files
 *
 */

// import scripts

import $ from 'jquery';
import { scroll } from './scroll';

const App = {

	// start app

	ready: function() {
		scroll();
	},

	load: function() {
		
	}
};

$(document).ready(App.ready);

$(window).on('load', App.load);

